'use strict';

var _ = require('lodash');
var util = require('_core_ext/util');

var JSConstants = require('_core_ext/pages/tradecard/constants');
var prefillAddress = require('./prefillAddress');

var cache = {};

function setSearchPlaceholder(placeholder) {
    var $searchField = $(JSConstants.ADDRESS_SEARCH_INPUT);

    if (!placeholder) {
        var defaultPlaceholder = Resources.SEARCH_ADDRESS_PLACEHOLDER;
        placeholder = defaultPlaceholder ? defaultPlaceholder : '';
    }

    $searchField.attr('placeholder', placeholder);
}

function fillAddress(line1, line2, line3, line4) {
    $(JSConstants.ADDRESS_LINE1).html(line1);
    $(JSConstants.ADDRESS_LINE2).html(line2);
    $(JSConstants.ADDRESS_LINE3).html(line3);
    $(JSConstants.ADDRESS_LINE4).html(line4);
    setSearchPlaceholder(line1 + ' ' + line2 + ' ' + line3);
}

function touchManualFields() {
    $(JSConstants.ADDRESS_MANUAL_FIELDS).find('input, select').blur();
}

function scrollToAddressFormSection () {
    var $addressFormSection = $(JSConstants.ID_ADDRESS_FORM_SECTION);
    util.scrollBrowserTo($addressFormSection, 500, 5);
}

function locationSearch() {
    var addressFields = [{
        fieldName: '_address1',
        qasName: 'addressLine1'
    }, {
        fieldName: '_address2',
        qasName: 'addressLine3'
    }, {
        fieldName: '_city',
        qasName: 'locality'
    }, {
        fieldName: '_county',
        qasName: 'province'
    }, {
        fieldName: '_postal',
        qasName: 'postalCode'
    }, {
        fieldName: '_postalCode',
        qasName: 'postalCode'
    }];

    require('_core_ext/globalintuitive/contact-data-services');

    var token = SitePreferences.QAS_TOKEN,
        qasLocales = SitePreferences.QAS_LOCALES,
        localeCodeMapping = SitePreferences.LOCALE_CODE_MAPPING;

    var allowedLocale = _.find(qasLocales, function (obj) {
        return obj.locale === SitePreferences.LOCALE;
    });

    // initialize it only on allowed locales (NOTE: it can be changed if we will use this feature on other locales)
    if (allowedLocale && SitePreferences.QAS_ENABLED && SitePreferences.QAS_SUGGESTION_ENABLED && token) {
        var $searchAddress = $('input[name*="_search"]');

        if (!$searchAddress.length) {
            return;
        }

        var country = $("[name*='_country']").val();
        var locObj = _.find(localeCodeMapping, function (obj) {
            return obj.label === country;
        });

        if (locObj) {
            country = locObj.countryCode;
        }
        var pcaObj = _.find(qasLocales, function (obj) {
            return obj.contryCode === country;
        });

        var currentCountry = pcaObj ? pcaObj.QASContryCode : '';

        // set options for Global Intuitive
        var qasOptions = {
            minStrLength: SitePreferences.QAS_MIN_STR_LENGTH || 0,
            maxSize: SitePreferences.QAS_MAX_LIST_COUNT || 25,
            placeholderText: Resources.SEARCH_ADDRESS_PLACEHOLDER,
            token: token,
            elements: {
                input: $searchAddress[0],
                countryList: {value: currentCountry}
            }
        };

        var populatedFields = [];
        for (var i = 0; i < addressFields.length; i++) {
            var selector = $('input[name="dwfrm_profile_tradecardaddress' + addressFields[i].fieldName + '"]');
            if (selector.length) {
                qasOptions.elements[addressFields[i].qasName] = selector[0];
                populatedFields.push(selector);
            }
        }

        // initialize the Global Intuitive (Address search)
        /*eslint-disable */
        var address = new ContactDataServices.address(qasOptions);
        address.events.on('post-formatting-search', function(experianAddress) {
            if (!experianAddress.address || !experianAddress.components) {
                $(JSConstants.ADDRESS_MANUAL).trigger('click');
            }

            var addressLine1Obj;
            var addressLine2Obj;
            var address = experianAddress.address.reduce(function (accumulator, currentValue) {
                if ('addressLine1' in currentValue) {
                    addressLine1Obj = currentValue;
                } else if ('addressLine2' in currentValue) {
                    addressLine2Obj = currentValue;
                }
                return Object.assign(accumulator, currentValue);
            }, {});

            addressLine1Obj.addressLine1 = [
                addressLine1Obj.addressLine1,
                addressLine2Obj.addressLine2
            ].filter(value => value).join(', ');

            if (address.addressLine1 && address.locality) {
                // Select provided address if provided info - valid

                fillAddress(
                    [address.addressLine1, address.addressLine2].join(', '),
                    address.addressLine3,
                    address.locality,
                    address.postalCode
                );

                $(JSConstants.ADDRESS_RESULT).show();

                setTimeout(function() {
                    $(JSConstants.ADDRESS_RESULT).trigger('change');
                    touchManualFields();
                });
            } else {
                // On invalid info - manual mode
                onAddressClear();
                onAddressManualEdit();
            }
        });
    }
}

function onAddressManualEdit(e) {
    e && e.preventDefault();

    cache.status = $(JSConstants.ADDRESS_RESULT).is(':visible') ? 'edit' : 'add';
    $(JSConstants.ADDRESS_MANUAL_FIELDS).show();
    $(JSConstants.ADDRESS_SEARCH).hide();
    $(JSConstants.ADDRESS_RESULT).hide();
    $(JSConstants.ADDRESS_RESULT).trigger('change');

    cache.manual = $(JSConstants.ADDRESS_MANUAL_FIELDS).serializeArray();
    validate();

    scrollToAddressFormSection();
}

function onAddressClear(e) {
    e && e.preventDefault();

    $(JSConstants.ADDRESS_SEARCH).show();
    var $searchField = $(JSConstants.ADDRESS_SEARCH_INPUT),
        $addressResult = $(JSConstants.ADDRESS_RESULT);

    $searchField.val('');
    window.dispatchEvent(new Event('custom.address_hide-picklist'));

    $(JSConstants.ADDRESS_MANUAL_FIELDS).hide()
        .find('input, textarea').val('');

    prefillAddress();

    $addressResult.hide();
    $addressResult.trigger('change');
    setSearchPlaceholder();
}

function initEvents() {
    $(document)
        .on('click', JSConstants.ADDRESS_MANUAL, onAddressManualEdit)
        .on('click', JSConstants.ADDRESS_CLEAR, onAddressClear)
        .on('click', JSConstants.ADDRESS_ADD_ADDRESS, function (e) {
            e.preventDefault();

            var addressLine1 = $(JSConstants.ADDRESS_MANUAL_LINE1).find('input').val();
            var addressLine2 = $(JSConstants.ADDRESS_MANUAL_LINE2).find('input').val();
            var locality = $(JSConstants.ADDRESS_MANUAL_LOCALITY).find('input').val();
            var postalCode = $(JSConstants.ADDRESS_MANUAL_POSTAL).find('input').val();

            fillAddress(
                addressLine1,
                addressLine2,
                locality,
                postalCode
            );

            $(JSConstants.ADDRESS_MANUAL_FIELDS).hide();
            $(JSConstants.ADDRESS_SEARCH).show();
            $(JSConstants.ADDRESS_RESULT).show();

            scrollToAddressFormSection();
            $(JSConstants.ADDRESS_RESULT).trigger('change');
        })
        .on('click', JSConstants.ADDRESS_CANCEL_BT, function (e) {
            e.preventDefault();

            if(cache.manual.length > 0) {
                cache.manual.forEach(function (field) {
                    $("input[name='" + field.name + "'], select[name='" + field.name + "']").val(field.value);
                })
            }

            $(JSConstants.ADDRESS_MANUAL_FIELDS).hide();
            $(JSConstants.ADDRESS_SEARCH).show();

            if(cache.status === 'edit') {
                $(JSConstants.ADDRESS_RESULT).show();
            }

            scrollToAddressFormSection();
            $(JSConstants.ADDRESS_RESULT).trigger('change');
        })
        .on('change', '[data-destination-step]', validate)
        .find(JSConstants.ADDRESS_MANUAL_FIELDS).on('change', 'input:visible, select:visible', validate);
}

function validate () {
    var $el = $(JSConstants.ADDRESS_MANUAL_FIELDS);
    var shouldValidate = $el.is(':visible');

    if (shouldValidate) {
        var valid = true;
        var validator = $el.validate();

        $el.find('input, select').each(function (index, el) {
            valid = valid && validator && validator.check(el);
        })

        $(JSConstants.ADDRESS_ADD_ADDRESS).prop('disabled', !valid);
    }
}

module.exports = {
    init: function () {
        locationSearch();
        initEvents();
    }
};